import styled from 'styled-components';
import { Button } from '../Button';

/**
 * Nothing to see here for now
 */

export const MessageTitle = styled.div`
  color: ${({ theme }) => theme.color.ui2};
  ${({ theme }) => theme.font.t1};
  margin-bottom: 20px;
`;

export const MessageDetail = styled.div`
  ${({ theme }) => theme.font.t3};
  font-style: normal;
  line-height: 120%;
  color: ${({ theme }) => theme.color.ui2};
`;

export const StyledButton = styled(Button)`
  margin-top: 40px;
`;
